import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { instance } from "@/lib/axios/instance";
import { GetTenantsResponse } from "@/types/response/GetTenantsResponse";

const PAGE_SIZE = 20;

interface UseTenantsInfiniteParams {
  search?: string;
}

export function useTenantsInfinite({ search }: UseTenantsInfiniteParams = {}) {
  return useInfiniteQuery<GetTenantsResponse, AxiosError>({
    queryKey: ["tenants", "infinite", search],
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      instance
        .get("/api/v2/Tenants", {
          params: {
            search: search || undefined,
            page: pageParam,
            pageSize: PAGE_SIZE,
          },
        })
        .then((res) => res.data),
    getNextPageParam: (lastPage, allPages) => {
      const totalRecords = lastPage.totalRecords;
      const totalFetched = allPages.reduce(
        (acc, page) => acc + page.data.length,
        0
      );
      return totalFetched < totalRecords ? allPages.length + 1 : undefined;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: keepPreviousData,
  });
}
